import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { Store } from '@ngrx/store';
import {
  EThemeActions,
  InitTheme,
  SetTheme,
} from '@myStore/theme/theme.actions';

@Injectable()
export class ThemeEffects {
  constructor(private _actions$: Actions, private _store: Store<IAppState>) {}

  $setTheme = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SetTheme>(EThemeActions.SetTheme),
        map(action => {
          localStorage.setItem('theme', action.theme);
        })
      );
    },
    { dispatch: false }
  );

  $initTheme = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<InitTheme>(EThemeActions.InitTheme),
        map(() => {
          const theme = localStorage.getItem('theme') || 'light';
          this._store.dispatch(new SetTheme(theme));
        })
      );
    },
    { dispatch: false }
  );
}
